import React, { useState } from "react"

import { NotificationManager } from "react-notifications"

import { Button } from "~tailwindui/Basics"

import { teacherClient as client } from "src/urql-client"

import { gql, useMutation } from "hooks/urql"

import UntypedAutocompleteSelect from "components/Forms/AutocompleteSelect"

const AutocompleteSelect = UntypedAutocompleteSelect as React.ComponentType<any>

type StudentOption = {
  label: string
  value: string
}

const InviteStudentForm = () => {
  const [selectedStudent, setSelectedStudent] = useState<StudentOption | null>(
    null
  )
  const [mutationResult, runMutation]: any[] = useMutation(
    createAudioRoomInviteMutation,
    client
  )

  const inviteStudent = () => {
    if (!selectedStudent) return

    runMutation({ studentId: selectedStudent.value })
      .then(result => {
        const { failures } = result.data.createAudioRoomInvite
        if (failures.length > 0) {
          NotificationManager.error(failures[0].message)
        } else {
          NotificationManager.success(
            `Invite sent to ${selectedStudent.label}.`
          )
          setSelectedStudent(null)
        }
      })
      .catch(() => NotificationManager.error("Unable to send invite"))
  }

  return (
    <>
      <div className="mb-6">
        <div className="mb-2 min-w-[250px] text-black">
          <AutocompleteSelect
            api="/api/teachers/students/autocomplete_full_name"
            onChange={setSelectedStudent}
            placeholder="Invite students..."
            value={selectedStudent}
          />
        </div>
        <Button
          className={!selectedStudent && "hidden"}
          disabled={!selectedStudent || mutationResult.fetching}
          onClick={inviteStudent}
        >
          Invite
        </Button>
      </div>
    </>
  )
}

const createAudioRoomInviteMutation = gql`
  mutation CreateAudioRoomInvite($studentId: ID!) {
    createAudioRoomInvite(studentId: $studentId) {
      failures {
        message
      }
    }
  }
`

export default InviteStudentForm
